export default {
  login: {
    txt1: "遊戲內神祕程式碼驗證",
    txt2: "請輸入神秘代碼",
    txt3: "驗證",
    txt4: "請選擇伺服器",
    txt5: "請選擇角色資訊",
    txt6: "登入",
    txt7: "幫助中心",
  },
  nav: {
    txt1: "首頁",
    txt2: "賽事直播",
    txt3: "賽事排行榜",
    txt4: "賽事MVP",
    txt5: "觀賽領獎勵",
    txt6: "直播互動領週邊",
    txt7: "賽事獎勵",
    txt8: "賽事創作者計畫",
  },
  live: {
    txt1: "賽程",
    txt2: "更多精彩直播間",
    txt3: "直播時間：",
    txt4: "直播內容：",
    txt5: "進入直播間",
    txt6: "直播時間",
    txt7: "對陣情況",
    txt8: "你好, 請登入",
  },
  process: {
    nav1: "積分賽排行榜",
    nav2: "淘汰賽-晉級圖",
    nav3: "總積分排行榜",
    txt1: "排名",
    txt2: "戰隊名稱",
    txt3: "伺服器",
    txt4: "總分",
    txt5: "賽區",
    txt6: "擊殺",
    list: ["賽區Ⅰ", "賽區Ⅱ", "賽區Ⅲ", "賽區Ⅳ"],
    img: require("@/assets/en-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "福利一：半決賽-第一場比賽神秘禮包碼",
    time2: "2023/11/24",
    title2: "福利二：半決賽-第二場比賽神秘禮包碼",
    time3: "2023/11/25",
    title3: "福利三：冠軍隊伍福利禮包碼",
    p1: "競猜幣",
    p2: "鑽石",
    p3: "公會獎章箱",
    p4: "大型zeny寶箱",
    p5: "卡片抽獎券（稀有）",
    p6: "高級精煉附魔禮盒",
  },
  mvp: {
    txt1: "歷史最高數據",
    txt2: "角色伺服器",
    txt3: "戰隊名稱",
    txt4: "角色暱稱",
    txt5: "角色等級",
    txt6: "職業",
    txt7: "32強淘汰賽",
    txt8: "總決賽",
  },
  task: {
    loginTip: "親愛的冒險者，請先登入以完成任務，領取獎勵",
    reward830: "狄羅雕刻自選禮盒*10 \n觀星幻境培養材料x50",
    task830: "8.30日累計觀看<span>10分鐘</span>",
    reward91: "狄羅之塵*300 \n觀星幻境培養材料x50",
    task91: "9.1日累計觀看<span>10分鐘</span>",
    reward92: "珍貴印記隨機禮盒*10 \n觀星幻境培養材料x100",
    task92: "9.2日累計觀看<span>10分鐘</span>",
    reward94: "閃耀魔靈隨機箱*3\n 觀星幻境培養材料x100",
    task94: "9.4日累計觀看<span>15分鐘</span>",
    reward96: "閃耀魔靈隨機箱*3\n 觀星幻境培養材料x100",
    task96: "9.6日累計觀看<span>15分鐘</span>",
    reward98: "閃耀魔靈之鑰*1 微光魔靈之鑰*1 \n瑕疵的印記結晶*10",
    task98: "9.8日累計觀看<span>15分鐘</span>",
    rewardTotal2: "附魔硬幣自選箱x2 \n附魔折價券x100",
    taskTotal2: "完成2個觀賽任務",
    rewardTotal5: "黃昏臂章x1 扭蛋抽獎券x5 \n特別召喚券x5",
    taskTotal5: "完成5個觀賽任務",
    txt7: "當下進度",
    txt8: "未完成",
    txt9: "查 看",
    txt10: "領 取",
    txt11: "已領取",
  },
  reward: [
    {
      type: "淘汰賽",
      item: [
        {
          name: "冠軍",
          image: require("@/assets/en-re1.png"),
          imageM: require("@/assets/mobile/en-re1.png"),
          list: [
            {
              name: "冠軍坐骑",
              amount: "",
            },
            {
              name: "稱號-2024索爾盃冠軍戰隊",
              amount: "",
            },
            {
              name: "索爾盃冠軍氣泡框",
              amount: "",
            },
            {
              name: "索爾盃冠軍頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "20",
            },
            {
              name: "喵果",
              amount: "20000",
            },
            {
              name: "鑽石",
              amount: "5000",
            },
            {
              name: "橙色印記自選箱III",
              amount: "10",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "30",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "40",
            },
            {
              name: "月之章",
              amount: "8",
            },
            {
              name: "神王雕像自選盒",
              amount: "10",
            },
          ],
        },
        {
          name: "亞軍",
          image: require("@/assets/en-re2.png"),
          imageM: require("@/assets/mobile/en-re2.png"),
          list: [
            {
              name: "稱號-2024索爾盃亞軍戰隊",
              amount: "",
            },
            {
              name: "索爾盃亞軍氣泡框",
              amount: "",
            },
            {
              name: "索爾盃亞軍頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "20",
            },
            {
              name: "喵果",
              amount: "10000",
            },
            {
              name: "鑽石",
              amount: "4500",
            },
            {
              name: "橙色印記自選箱III",
              amount: "10",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "25",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "36",
            },
            {
              name: "月之章",
              amount: "6",
            },
            {
              name: "神王雕像自選盒",
              amount: "8",
            },
          ],
        },
        {
          name: "4強",
          image: require("@/assets/en-re3.png"),
          imageM: require("@/assets/mobile/en-re3.png"),
          list: [
            {
              name: "稱號-2024索爾盃4強戰隊",
              amount: "",
            },
            {
              name: "索爾盃4強氣泡框",
              amount: "",
            },
            {
              name: "索爾盃4強頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "17",
            },
            {
              name: "喵果",
              amount: "5000",
            },
            {
              name: "鑽石",
              amount: "4000",
            },
            {
              name: "橙色印記自選箱III",
              amount: "8",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "20",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "32",
            },
            {
              name: "月之章",
              amount: "4",
            },
            {
              name: "神王雕像自選盒",
              amount: "6",
            },
          ],
        },
        {
          name: "8強",
          image: require("@/assets/en-re4.png"),
          imageM: require("@/assets/mobile/en-re4.png"),
          list: [
            {
              name: "稱號-2024索爾盃8強戰隊",
              amount: "",
            },
            {
              name: "索爾盃8強氣泡框",
              amount: "",
            },
            {
              name: "索爾盃8強頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "15",
            },
            {
              name: "喵果",
              amount: "3000",
            },
            {
              name: "鑽石",
              amount: "3000",
            },
            {
              name: "橙色印記自選箱III",
              amount: "6",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "15",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "28",
            },
            {
              name: "月之章",
              amount: "3",
            },
            {
              name: "神王雕像自選盒",
              amount: "4",
            },
          ],
        },
        {
          name: "16強",
          image: require("@/assets/en-re5.png"),
          imageM: require("@/assets/mobile/en-re5.png"),
          list: [
            {
              name: "稱號-2024索爾盃16強戰隊",
              amount: "",
            },
            {
              name: "索爾盃16強氣泡框",
              amount: "",
            },
            {
              name: "索爾盃16強頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "7",
            },
            {
              name: "喵果",
              amount: "2000",
            },
            {
              name: "鑽石",
              amount: "2000",
            },
            {
              name: "橙色印記自選箱III",
              amount: "4",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "10",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "24",
            },
            {
              name: "月之章",
              amount: "2",
            },
            {
              name: "神王雕像自選盒",
              amount: "2",
            },
          ],
        },
        {
          name: "32強",
          image: require("@/assets/en-re6.png"),
          imageM: require("@/assets/mobile/en-re6.png"),
          list: [
            {
              name: "稱號-2024索爾盃32強戰隊",
              amount: "",
            },
            {
              name: "索爾盃32強氣泡框",
              amount: "",
            },
            {
              name: "索爾盃32強頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "5",
            },
            {
              name: "喵果",
              amount: "1500",
            },
            {
              name: "橙色印記自選箱III",
              amount: "2",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "5",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "20",
            },
            {
              name: "月之章",
              amount: "1",
            },
            {
              name: "鑽石",
              amount: "1500",
            },
          ],
        },
      ],
    },
    {
      type: "積分賽",
      item: [
        {
          name: "晉級1-4",
          image: require("@/assets/en-re7.png"),
          imageM: require("@/assets/mobile/en-re7.png"),
          list: [
            {
              name: "索爾盃菁英頭像",
              amount: "",
            },
            {
              name: "稱號-2024索爾盃精英戰隊",
              amount: "",
            },
            {
              name: "索爾盃精英氣泡框",
              amount: "",
            },
            {
              name: "索爾盃精英頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "40",
            },
            {
              name: "喵果",
              amount: "2500",
            },
            {
              name: "橙色印記自選箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "30",
            },
            {
              name: "時空系列羽毛自選箱",
              amount: "50",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "15",
            },
            {
              name: "鑽石",
              amount: "2500",
            },
          ],
        },
        {
          name: "晉級5-8",
          image: require("@/assets/en-re8.png"),
          imageM: require("@/assets/mobile/en-re8.png"),
          list: [
            {
              name: "索爾盃菁英頭像",
              amount: "",
            },
            {
              name: "稱號-2024索爾盃精英戰隊",
              amount: "",
            },
            {
              name: "索爾盃精英氣泡框",
              amount: "",
            },
            {
              name: "索爾盃精英頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "35",
            },
            {
              name: "喵果",
              amount: "2300",
            },
            {
              name: "橙色印記自選箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "25",
            },
            {
              name: "時空系列羽毛自選箱",
              amount: "45",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "13",
            },
            {
              name: "鑽石",
              amount: "2300",
            },
          ],
        },
        {
          name: "晉級9-16",
          image: require("@/assets/en-re9.png"),
          imageM: require("@/assets/mobile/en-re9.png"),
          list: [
            {
              name: "索爾盃菁英頭像",
              amount: "",
            },
            {
              name: "稱號-2024索爾盃精英戰隊",
              amount: "",
            },
            {
              name: "索爾盃精英氣泡框",
              amount: "",
            },
            {
              name: "索爾盃精英頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "33",
            },
            {
              name: "喵果",
              amount: "2000",
            },
            {
              name: "橙色印記自選箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "20",
            },
            {
              name: "時空系列羽毛自選箱",
              amount: "40",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "12",
            },
            {
              name: "鑽石",
              amount: "2000",
            },
          ],
        },
        {
          name: "晉級17-32",
          image: require("@/assets/en-re10.png"),
          imageM: require("@/assets/mobile/en-re10.png"),
          list: [
            {
              name: "索爾盃菁英頭像",
              amount: "",
            },
            {
              name: "稱號-2024索爾盃精英戰隊",
              amount: "",
            },
            {
              name: "索爾盃精英氣泡框",
              amount: "",
            },
            {
              name: "索爾盃精英頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "30",
            },
            {
              name: "喵果",
              amount: "1900",
            },
            {
              name: "橙色印記自選箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "19",
            },
            {
              name: "時空系列羽毛自選箱",
              amount: "38",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "11",
            },
            {
              name: "鑽石",
              amount: "1900",
            },
          ],
        },
        {
          name: "未晉級",
          image: require("@/assets/en-re11.png"),
          imageM: require("@/assets/mobile/en-re11.png"),
          list: [
            {
              name: "索爾盃菁英頭像",
              amount: "",
            },
            {
              name: "稱號-2024索爾盃精英戰隊",
              amount: "",
            },
            {
              name: "索爾盃精英氣泡框",
              amount: "",
            },
            {
              name: "索爾盃精英頭像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "28",
            },
            {
              name: "喵果",
              amount: "1800",
            },
            {
              name: "橙色印記自選箱III",
              amount: "2",
            },
            {
              name: "光暗系列羽毛自選箱",
              amount: "18",
            },
            {
              name: "時空系列羽毛自選箱",
              amount: "36",
            },
            {
              name: "雕像部位材料自選盒F",
              amount: "10",
            },
            {
              name: "鑽石",
              amount: "1800",
            },
          ],
        },
        {
          name: "參與獎",
          image: require("@/assets/en-re12.png"),
          imageM: require("@/assets/mobile/en-re12.png"),
          list: [
            {
              name: "鑽石",
              amount: "100",
            },
            {
              name: "強者印記",
              amount: "200",
            },
            {
              name: "稀有印記隨機禮盒",
              amount: "1",
            },
            {
              name: "時空系列羽毛自選箱",
              amount: "5",
            },
            {
              name: "超级餅乾",
              amount: "5",
            },
            {
              name: "紫色羽毛自選箱",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "禮包碼",
    txt2: "複製",
    txt3: "複製成功",
  },
};
